import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useLazyGetOrganisationIdFromSubdomainQuery } from '@/app/services/organisation'
import { selectOrganisationSubdomain, setOrganisationSubdomain } from '@/app/slices/organisationSlice'

export function useCustomDomain() {
    const dispatch = useDispatch()
    const currentSubdomain = useSelector(selectOrganisationSubdomain)

    const hostname = window.location.hostname
    const excludedHostnames = ['localhost', 'qmapi.tempustoolsinc.com']
    const queryParams = new URLSearchParams(window.location.search)
    const subdomainFromQuery = queryParams.get('subdomain')

    const subdomainFromHostname = excludedHostnames.includes(hostname)
        ? null
        : window.location.hostname.split('.').slice(0, -2).join('.')

    const subdomain = subdomainFromQuery || subdomainFromHostname

    const [getOrganisationId, { isLoading: isLoadingOrgId, isSuccess: isSuccessOrgId }] =
        useLazyGetOrganisationIdFromSubdomainQuery()

    const getOrganisationIdFromSubdomain = useCallback(async () => {
        try {
            if (!subdomain) {
                return null
            }
            await getOrganisationId({ subdomain }).unwrap()
        } catch (error) {
            console.error(error)
        }
    }, [getOrganisationId, subdomain])

    useEffect(() => {
        if (subdomain && subdomain !== currentSubdomain) {
            dispatch(setOrganisationSubdomain(subdomain))
            getOrganisationIdFromSubdomain()
        }
    }, [currentSubdomain, dispatch, getOrganisationIdFromSubdomain, subdomain])

    return {
        isSuccessOrgId,
        isLoadingOrgId,
        subdomain,
        getOrganisationIdFromSubdomain,
    }
}
